import { render } from "./Takes.vue?vue&type=template&id=7724d879&scoped=true&ts=true"
import script from "./Takes.vue?vue&type=script&lang=ts"
export * from "./Takes.vue?vue&type=script&lang=ts"

import "./Takes.vue?vue&type=style&index=0&id=7724d879&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7724d879"]])

export default __exports__